import sanitizeHtml from "sanitize-html";

const allowedTags = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "p",
  "a",
  "ul",
  "ol",
  "nl",
  "li",
  "b",
  "i",
  "strong",
  "em",
  "strike",
  "code",
  "hr",
  "br",
  "div",
  "table",
  "thead",
  "caption",
  "tbody",
  "tr",
  "th",
  "td",
  "colgroup",
  "col",
  "pre",
  "iframe",
  "u",
  "s",
  "img",
  "video",
  "span",
];

export const DEFAULT_CONTENT = "<p></p>";

/**
 * Legacy plain-text values (no HTML tags) used newlines as paragraph breaks.
 * Stored editor content is already HTML, so leave it alone.
 */
export const normaliseIncomingHtml = (value: string) => {
  if (!value.includes("<") && value.includes("\n")) {
    return value.split("\n").join("<p>");
  }
  return value;
};

export const sanitiseValue = (value: string) =>
  sanitizeHtml(value, {
    allowedTags,
    allowedAttributes: {
      a: [
        "href",
        "name",
        "rel",
        "target",
        "auto",
        "class",
        "data-mention-atom-id",
        "data-mention-atom-name",
        "data-ext",
        "data-name",
        "data-url",
        "style",
      ],
      img: ["src", "width", "height"],
      div: ["style"], // alignment
      span: ["src", "name", "class", "data-ext", "data-node", "style"], // legacy file
      i: ["class"],
      iframe: [
        "src",
        "allowfullscreen",
        "width",
        "height",
        "title",
        "frameborder",
        "allow",
        "referrerpolicy",
      ],
      video: ["src", "allowfullscreen", "width", "height"],
      table: ["style"],
      col: ["style"],
      th: ["colspan", "rowspan", "colwidth", "style"],
      td: ["colspan", "rowspan", "colwidth", "style"],
    },
    allowedStyles: {
      table: { width: [/^\d+px$/], "min-width": [/^\d+px$/] },
      col: { width: [/^\d+px$/], "min-width": [/^\d+px$/] },
      th: { "text-align": [/^(left|center|right)$/] },
      td: { "text-align": [/^(left|center|right)$/] },
    },
    allowedIframeDomains: ["youtube.com", "vimeo.com", "powerbi.com"],
  });

/**
 * Plain text via TipTap's `getText()`, which respects each node's `renderText`
 * (mentions, files, hard breaks, etc.).
 */
export const getEditorPlainText = (editor: {
  getText: (options?: { blockSeparator?: string }) => string;
}) => editor.getText({ blockSeparator: "\n" }).trim();
